import useGetApi from 'src/api/useGetApi';
import { keepPreviousData } from '@tanstack/react-query';
import { ProductAttribute } from 'src/types/application/inventory-management/ProductV2DTO';

interface GetFilteredProductAttributesResponse {
  attributes: ProductAttribute[];
}

interface QueryParams {
  // selectedAttributes: { [productAttributeId]: coreEnumOptionId }
  selectedAttributes?: Record<string, string>;
  customerId?: string;
}

const useFilteredProductAttributes = (
  productId?: string,
  params?: QueryParams,
  enabled?: boolean,
) => {
  return useGetApi<GetFilteredProductAttributesResponse>({
    endpoint: `inventory-management/products-v2/${productId}/filtered-attributes`,
    queryParameters: params,
    options: {
      enabled: enabled && !!productId,
      placeholderData: keepPreviousData,
    },
  });
};

export default useFilteredProductAttributes;
